
import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Collapse,
} from "reactstrap"
import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const SubscriptionList = () => {
  // ---------------------Collapse Start-------------------------
  const [faq1, setFaq1] = useState(false)
  // ---------------------Collapse End-------------------------

  const [Subscription_Modal, setSubscription_Modal] = useState(false)

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function AddSubscription_Modal() {
    setSubscription_Modal(!Subscription_Modal)
    removeBodyCss()
  }

  const [selectedGroup, setselectedGroup] = useState(null)
  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
    },
  ]

  const [totalSize, setTotalSize] = useState(3)

  const data = {
    columns: [
      {
        text: "Plan Name",
        dataField: "PlanName",
        style: { width: "12%" },
      },
      {
        text: "Effective Date",
        dataField: "EffectiveDate",
        style: { width: "10%" },
      },
      {
        text: "Duration",
        dataField: "Duration",
        style: { width: "8%" },
      },
      {
        text: "View Contact",
        dataField: "ViewContact",
        style: { width: "10%" },
      },
      {
        text: "Can See Visitor Details",
        dataField: "CanSeeVisitorDetails",
        style: { width: "16%" },
      },
      {
        text: "Price",
        dataField: "Price",
        style: { width: "10%" },
      },
      {
        text: "Status",
        dataField: "Status",
        style: { width: "10%" },
      },
    ],
    rows: [
      {
        PlanName: "Nilesh",
        EffectiveDate: "01-OCT-2022",
        Duration: "15",
        ViewContact: "+91 9601615060",
        CanSeeVisitorDetails: "Krishna Soni",
        Price: "200",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddSubscription_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        PlanName: "Nilesh",
        EffectiveDate: "01-OCT-2022",
        Duration: "15",
        ViewContact: "+91 9601615060",
        CanSeeVisitorDetails: "Krishna Soni",
        Price: "200",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddSubscription_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        PlanName: "Nilesh",
        EffectiveDate: "01-OCT-2022",
        Duration: "15",
        ViewContact: "+91 9601615060",
        CanSeeVisitorDetails: "Krishna Soni",
        Price: "200",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              onClick={() => {
                AddSubscription_Modal()
              }}
              data-toggle="modal"
              data-target=".bs-example-modal-lg"
            >
              <i class="fa fa-edit"></i>
            </button>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Subscription List | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="Subscription List"
            />
            <Col sm={6}>
              <div className="float-end d-none d-md-block pt-2">
                <Button
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  onClick={() => {
                    AddSubscription_Modal()
                  }}
                  data-toggle="modal"
                  data-target=".bs-example-modal-lg"
                >
                  Add Subscription
                </Button>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="accordion mb-3" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button font-size-15 faq"
                      style={{
                        backgroundColor: "rgb(164, 229, 207)",
                        height: "40px",
                        color: "#000",
                      }}
                      type="button"
                      onClick={() => {
                        setFaq1(!faq1)
                      }}
                    >
                      <i class="fas fa-filter"></i> &nbsp;Filter Subscription List
                    </button>
                  </div>
                  <Collapse isOpen={faq1} className="accordion-collapse">
                    <div className="accordion-body">
                      <Row>
                        <Col lg="5">
                          <div className="mb-3">
                            <Label>Plan Name</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="PlanName"
                              id="PlanName"
                            />
                          </div>
                        </Col>
                       
                        <Col lg="5">
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              value={selectedGroup}
                              onChange={() => {
                                handleSelectGroup()
                              }}
                              options={optionGroup}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col lg="2">
                            
                          <div className="float-end d-none d-md-block pt-4">
                            <Button
                              color="primary"
                              className="btn btn-primary waves-effect waves-light mt-1"
                            >
                              Search
                            </Button>{' '}
                            <Button
                              color="outline-primary"
                              className="btn btn-outline-primary mt-1"
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable responsive bordered data={data} noBottomColumns/> */}
                  <CustomTable
                    keyField="SubscriptionList"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        size="md"
        isOpen={Subscription_Modal}
        toggle={() => {
          AddSubscription_Modal()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Add Subscription
          </h5>
          <button
            onClick={() => {
              AddSubscription_Modal()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="PlanName"
                    label="Plan Name"
                    placeholder="Plan Name"
                    type="text"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="EffectiveDate"
                    label="Effective Date"
                    type="date"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
              <FormGroup className="mb-3">
                  <AvField
                    name="Duration"
                    label="Duration"
                    placeholder="Duration"
                    type="text"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="View Contact"
                    name="ViewContact"
                    placeholder="View Contact"
                    type="number"
                    className="form-control"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                <AvField
                    label="Price"
                    name="Price"
                    placeholder="Price"
                    type="number"
                    className="form-control"
                  />
                </FormGroup>
              </Col>
              
              <Col md="6">
                <FormGroup className="mb-3 mt-4">
                    <div className="form-check pt-2">
                    <Label
                      className="form-check-label"
                      htmlFor="Allow_Candidate"
                    >
                      {" "}
                      Can See Visitor Details
                    </Label>
                    <Input
                      type="checkbox"
                      className="form-check-input"
                      id="Allow_Candidate"
                    />
                  </div>
                </FormGroup>
              </Col>


            </Row>
            <Button color="primary" className="mt-3" type="submit">
              Submit
            </Button>{" "}
            <Button
              color="outline-primary"
              className="mt-3"
              onClick={() => {
                AddSubscription_Modal()
              }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </Button>
          </AvForm>
        </div>
      </Modal>
    </React.Fragment>
  )
}
